declare global {
  interface Window {
    FS?: {
      identify: (userId?: string, data?: Record<string, string>) => void;
      event: (eventName: string, data: Record<string, string>) => void;
      getCurrentSessionURL: (atCurrentTime?: boolean) => string;
    };
    _fs_loaded?: string;
    Rollbar?: {
      configure: (configuration: RollbarConfiguration) => void;
      error: (message: string, payload?: unknown) => void;
    };
    _hsq: {
      push: (event: ['identify', unknown]) => void;
    };
    Intercom?: (funcName: string, params: unknown) => void;
  }
}

export interface RollbarConfigurationPayload {
  person?: {
    id: string | number;
    email: string;
  };
  fullstoryURL?: string;
}

export interface RollbarConfiguration {
  payload: RollbarConfigurationPayload;
  onSendCallback?: (
    isUncaught: boolean,
    args: unknown,
    payload: RollbarConfigurationPayload
  ) => void;
}

export const fullstory = window.FS;
